module.exports = __webpack_public_path__ + "img/manda_016.114bd8d8.png";